import * as z from "zod";
import { ConnectionView } from "./connection";

export const listConnections = {
  name: "listConnections" as const,
  input: z.object({}),
  output: z.object({ connections: z.array(ConnectionView) }),
};
